if(typeof __WEBPACK_EXTERNAL_MODULE_51__ === 'undefined') {var e = new Error("Cannot find module \"JSZip\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_51__;


//////////////////
// WEBPACK FOOTER
// external "JSZip"
// module id = 51
// module chunks = 0